<template>
  <div
      :data-testid="props.dataTestid ? props.dataTestid : 'event_filter'"
      :id="randomId"
  >
  <div class="max-w-md m-auto">
    <TsInput
        :dataTestid="componentName + '_search'"
        rounded
        :placeholder="useTranslation('searchEvents', 'Zoek evenementen') + '...'"
        v-model="inputModel"
        :append-class="twMerge('mb-8 mx-auto', inputModel && 'cursor-pointer')"
        :icon="
        inputModel
          ? 'material-symbols-light:close-rounded'
          : 'material-symbols-light:search'
      "
        @icon-click="handleClearSearch"
    />   
    <div class="flex justify-center">
      <TsRow class="space-x-2">
        <TsButton size="xs"
                v-for="el in tags"
                :key="el.id"
                rounded
                @click="handleModeFilter(el.id)"
                :label="el.label"
                :append-class="twMerge(
                    'max-sm:mb-4 border-0 !text-base focus:ring-0 ring-primary bg-natural-soft-white text-natural-grey hover:text-idle-white',
                    el.id.toLowerCase() === props.activeMode && 'border border-primary text-primary'
                )"
      />
      </TsRow>
    </div>
  </div>

    <TsMedia v-if="builderStore.month_array.length > 1" append-class="w-max">
      <TsMediaContent>
        <TsSelectBox
            :dataTestid="componentName + '_month'"
            variant="primary"
            size="sm"
            v-model="selectModel"
            :options="builderStore.month_array"
            input-class="w-14 text-primary"
            :placeholder="useTranslation('months', 'Maanden')"
        />
      </TsMediaContent>
    </TsMedia>
  </div>
</template>
<script setup lang="ts">
import {onMounted, ref} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";
const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);
const TsSelectBox = defineAsyncComponent(
    () => import('~/components/atoms/TsSelectBox.vue')
);

const componentName = "event_filter";
const inputModel = defineModel('input');
const selectModel = defineModel('select');
const builderStore = useBuilderStore();

type Props = {
  tags?: {id: string, label: string}[];
  dataTestid?: string;
  activeMode?: string;
};

const props = withDefaults(defineProps<Props>(), {
  tags: () => ([{id: 'all', label: useTranslation('all', 'Alle')}, {id: 'online', label: useTranslation('online', 'Online')}, {id: 'offline', label: useTranslation('offline', 'Offline')}]),
});

const emit = defineEmits(["clear-search", "change-mode"]);

function handleModeFilter(mode) {
  emit("change-mode", mode);
}

function handleClearSearch() {
  emit("clear-search");
}

const randomId = ref<string>("");

onMounted(() => {
  randomId.value = useRandomUUID();
});
</script>
